"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const KashooIcon = ({ className, width = '40', height = '40', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { role: "img", width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "currentColor", className: className, xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("g", { clipPath: "url(#clip0_1771_4810)" },
                    react_1.default.createElement("path", { d: "M29.0817 28.9901L21.8896 19.9739L29.0557 11.0098H10.9189V28.9901H29.0817Z", fill: "#FFB700" })),
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("clipPath", { id: "clip0_1771_4810" },
                        react_1.default.createElement("rect", { width: "18.1628", height: "17.9804", fill: "white", transform: "translate(10.9189 11.0098)" })))))));
};
exports.default = KashooIcon;
//# sourceMappingURL=KashooIcon.js.map